import { useLocation } from "react-router";

import { WardType } from "../constants/ward";
import { TWardType } from "../interfaces/WardInterface";

const wardTypes = Object.values(WardType);

// eslint-disable-next-line import/prefer-default-export
export function useWardTypeFromUrl(): TWardType | undefined {
  const { pathname } = useLocation();

  const wardType = pathname.split("/").filter(Boolean).pop();

  return wardTypes.includes(wardType as TWardType) ? (wardType as TWardType) : undefined;
}
